"use strict";
/*
 * Created on 26. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ResultSeverity_1 = require("../../../core/model/errors/ResultSeverity");

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");

var FlagSet_1 = require("../../../core/model/FlagSet");

var RequiresRecalculation_1 = require("../../../release/model/alerts/RequiresRecalculation");

var FinalProductPriceValidationKey_1 = require("../../../release/model/FinalProductPriceValidationKey");
/**
 * Purchase price changed event.
 * @author Radek Beran
 */


var PurchasePriceChanged =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(PurchasePriceChanged, _EntityEventFlag_1$En);

  function PurchasePriceChanged() {
    _classCallCheck(this, PurchasePriceChanged);

    return _possibleConstructorReturn(this, _getPrototypeOf(PurchasePriceChanged).apply(this, arguments));
  }

  _createClass(PurchasePriceChanged, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return PurchasePriceChanged;
}(EntityEventFlag_1.EntityEventFlag);

exports.PurchasePriceChanged = PurchasePriceChanged;
PurchasePriceChanged.TAG = EntityEventFlag_1.EntityEventFlag.register(PurchasePriceChanged);
PurchasePriceChanged.INSTANCE = new PurchasePriceChanged();
PurchasePriceChanged.MESSAGE = new ValidationResultObject_1.ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.PurchasePriceChanged, immutable_1.List.of(), null, null, FlagSet_1.FlagSet.of(ValidationResultFlag_1.ValidationResultFlag, RequiresRecalculation_1.RequiresRecalculation.INSTANCE));
PurchasePriceChanged.CLEANING_MESSAGE_PROTOTYPE = new ValidationResultObject_1.ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, FinalProductPriceValidationKey_1.FinalProductPriceMessageCode.PurchasePriceChanged, immutable_1.List.of(), null, null);